import React, { useCallback, useEffect, useMemo, useState, memo, useRef } from 'react';
import QRCode from 'qrcode.react';
import styles from './Form.module.scss';
import './customStyle.css';
import Button from '@src/components/button/Button';
import iconSrc from './assets/icon.png';
import IconOutline from 'src/assets/icons/outline.svg?react';
import IconHoverOutline from '@src/assets/icons/hover_outline.svg?react';
import InfoCircleIcon from '@src/assets/icons/infocircle.svg?react';
import OutlineIcon from 'src/assets/icons/outline.svg?react';
import TicketIcon from 'src/assets/icons/ticket.svg?react';
import WarningIcon from 'src/assets/icons/red-warning.svg?react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ExitTicketExpirationTime, ResearchExpirationTime } from '../../../../constants';
import { useNextContent } from '../../useNextContent';
import { ContentType, FeedbackFormContent, useCancelFeedbackFormMutation, useFeedbackFormLazyQuery } from '@api/graphql-codegen';
import CompleteModal from '@src/components/program-details/complete-modal/CompleteModal';
import { useToast, useExitTicketLocalStorage } from '@hooks';
import { FeedbackForm } from '@types';
import GenerateExitTicketLinkModal from '@src/components/program-details/exitticket-modal/GenerateExitTicketLinkModal';
import Spinner from '@src/components/spinner/Spinner';
import { isNumber } from "@src/utils/validation";
import { useStandaloneContent } from '@src/hooks/useStandaloneContent';
import { logger } from '../../../../utils/logger';

type Props = {
  formData?: string | null;
  jsonFormData: FeedbackForm;
  name: string;
  goBack?: () => void;
  setComplete: () => void;
  showMarkCompleteModal: boolean;
};

const createURL = (id: string) => {
  return `${window.location.origin}/ff/${id}`;
};

function FormGenerateContent(props: Props) {
  const {jsonFormData, name, goBack, formData } = props;
  const {lesson, course, content: contentValue, isPreProgramQuiz, grade, exitTicketActive, setExitTicketActive} = useStandaloneContent();
  const {hasNextContent} = useNextContent();
  const [feedbackForm, setFeedbackForm] = useState<FeedbackFormContent | undefined>();
  const [timeLeft, setTimeLeft] = useState<number>(ResearchExpirationTime * 60);
  // const [hideCanvas, setHideCanvas] = useState(true);
  // const [showNotify, setShowNotify] = useState(false);
  const [copyLinkHovered, setCopyLinkHovered] = useState(false);
  const [isLinkHovered, setIsLinkHovered] = useState(false);
  const [isQrHovered, setIsQrHovered] = useState(false);
  const [isActiveHovered, setIsActiveHovered] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [showRememberNotify, setShowRememberNotify] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [regenerate, setRegenerate] = useState(false);
  const containerRef = React.useRef(null);
  const { successToast } = useToast();
  const { getFormId, setFormId, removeFormId } = useExitTicketLocalStorage();

  const exitTicket = useMemo(() => (jsonFormData ? true : false), [jsonFormData]);
  const formTypeExitTicket = useMemo(() => (Number(jsonFormData?.surveyType) === 1 ? true : false), [jsonFormData]);
  const formTypePreProgram = useMemo(() => (Number(jsonFormData?.surveyType) === 3 ? true : false), [jsonFormData]);
  const Expiration_time = useMemo(() => ((Number(jsonFormData?.surveyType) === 2 ? ResearchExpirationTime : ExitTicketExpirationTime) * 60), [jsonFormData])
  let countDownTimer = useRef<NodeJS.Timeout | null>(null);

  const [getFeedbackForm, {loading: feedbackLoading}] = useFeedbackFormLazyQuery({fetchPolicy: 'network-only',
    onCompleted(res) {
      if (res.feedbackForm) {
        const currentTime = new Date().getTime();
        const expiration = parseInt(res.feedbackForm?.expirationAt ?? '0')
        const url = createURL(res.feedbackForm!.link ?? '');
        const ticketCount = res.feedbackForm?.exitTicketCount ?? 0;
        const expiryMins = (expiration - currentTime) / 1000;
        setFeedbackForm(res.feedbackForm)
        setShowExitModal(false)
        setExitTicketActive({
          status: true,
          formData: res.feedbackForm?.formData,
          type: res.feedbackForm?.type || undefined,
          exitTicketCount: ticketCount,
          expiryMinutes: expiryMins,
          copyLink: url,
          code: res.feedbackForm?.link ?? '',
          lessonNum: 0,
        });
      }
    },
    onError(e) {
      const errorMessage = e?.message || e?.graphQLErrors?.[0]?.message;
      if (errorMessage?.includes("already expired")) {
        removeFormId(lesson?.id)
        setExitTicketActive({
          lessonNum: 0,
          formData: exitTicketActive?.formData,
          status: false,
          type: exitTicketActive?.type,
          exitTicketCount: 0,
          expiryMinutes: 0,
          copyLink: "",
          code: "",
        })
      }
    }
  })
  const existingFormId = useMemo(() => lesson?.id ? getFormId(lesson?.id) : undefined, [getFormId, lesson?.id]);

  useEffect(() => {
    if (existingFormId) {
      getFeedbackForm({
        variables: {
          input: { id: existingFormId }
        }
      })
    } else {
      if (isPreProgramQuiz && contentValue?.type === ContentType.FORM) {
        setShowExitModal(true)
      }
    }
  }, [existingFormId, getFeedbackForm, isPreProgramQuiz, contentValue?.type]);

  const handleCompleteLesson = useCallback(async () => {

  }, [])

  const handleNotStartedLesson = useCallback(async () => {

  }, []);

  const [cancelFeedbackForm, {loading: canceling}] = useCancelFeedbackFormMutation({
    onError(e) {
      logger.debug(`[e]`, e);
    },
    onCompleted(data) {

      if (data.cancelFeedbackForm && !regenerate) {
        removeFormId(lesson?.id)
        setRegenerate(false)
        setExitTicketActive({
          lessonNum: 0,
          formData: exitTicketActive?.formData,
          status: false,
          type: exitTicketActive?.type,
          exitTicketCount: 0,
          expiryMinutes: 0,
          copyLink: "",
          code: "",
        });
      }
    }
  })

  useEffect(() => {
    if (timeLeft <= 0) {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
    }
  }, [timeLeft]);

  useEffect(() => {
    return () => {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
    }
  }, []);

  useEffect(() => {
    if(hasNextContent && feedbackForm) {
      setTimeout(() => {
        setShowRememberNotify(false);
        setTimeout(() => {
          setShowRememberNotify(false);
        }, 15000)
      }, 500)
    }
  }, [feedbackForm, lesson, hasNextContent])

  const handleGenerateForm = useCallback(() => {
    setRegenerate(false)
    setShowExitModal(false);
    setShowExitModal(true);
  }, []);

  const handleCopyToClipboard = useCallback((text: string) => () => {
    window.navigator.clipboard.writeText(text)
    setShowConfirm(true)
    setIsActiveHovered(false)
    setTimeout(() => {
      setShowConfirm(false)
    }, 3000)
  }, [setShowConfirm]);

  const generateLink = useCallback(() => {
    setFeedbackForm(undefined);
    if (exitTicket) {
      setShowExitModal(true);
    } else {
      setTimeLeft(Expiration_time);
      handleGenerateForm();
    }
  }, [Expiration_time, exitTicket, handleGenerateForm]);

  const handleActiveFormPreview = useCallback((feedback: FeedbackFormContent, expiration: any, ticketCount?: any) => {
    const formId = getFormId(lesson?.id)
    if (formId) {   // if exist ExitTicket link, cancel old one
      cancelFeedbackForm({
        variables: {
          input: { id: formId }
        }
      })
    }
    setFeedbackForm(feedback);
    const url = createURL(feedback.link ?? '');
    window.navigator.clipboard.writeText(url);
    successToast('Exit Ticket Link Successfully Created and Link copied successfully!');
    setFormId(lesson?.id, feedback.id)
    setExitTicketActive({
      status: true,
      formData: feedback.formData,
      type: feedback.type || undefined,
      exitTicketCount: ticketCount,
      expiryMinutes: expiration * 60,
      copyLink: url,
      code: feedback.link ?? '',
      lessonNum: 0,
    });
  },[lesson, successToast, setFormId, getFormId, cancelFeedbackForm, setExitTicketActive])

  const generateExitTicket = useCallback((e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation()
    } else {
      e.stopPropagation()
    }
    setRegenerate(true)
    setShowExitModal(true)
    setIsActiveHovered(false)
  },[])

  const cancelExitTicket = useCallback((e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation()
    } else {
      e.stopPropagation()
    }
    setRegenerate(false)
    const formId = getFormId(lesson?.id)
    if (formId) {
      cancelFeedbackForm({
        variables: {
          input: { id: formId }
        }
      })
    }
    setIsActiveHovered(false);
  },[lesson, getFormId, cancelFeedbackForm])

  const showExitTicketActive = (e: any) => {
    e.stopPropagation()
    setIsActiveHovered(current => !current);
  }

  const code = useMemo(() => {
    if (exitTicketActive) {
      return exitTicketActive.code
    }
    if(feedbackForm && feedbackForm?.link)
      return feedbackForm.link
    return ""
  }, [feedbackForm, exitTicketActive]);
  const codeList = code.split("");
  const shortLink = useMemo(() => (code ? `https://op.school/${code}` : ''), [code]);
  const longLink = createURL(code);
  const width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

  const content = useMemo(() => {
    if (exitTicketActive?.status) {
      const url = exitTicketActive!.copyLink;
      return (
        <div className={styles.wrapper} onClick={() => setIsActiveHovered(false)} ref={containerRef}>
          <div className={styles.mainContent}>
            <div className={styles.mainTitle}>
              {isPreProgramQuiz ? `Pre-Program Quiz` : name}
            </div>
            {/* {!!jsonFormData.instructions && <div className={styles.description}>{jsonFormData.instructions}</div>} */}
            <div className={styles.qrContent}>
                {<div className={styles.hoverQrTipView} style={{display: isQrHovered ? "block" : "none"}}>
                  <div className={styles.hoverTipTitle}>Scan the QR code</div>
                  <div className={styles.hoverTipDetail}>And answer the questions on your device</div>
                </div>}
                <div className={styles.qrCodeWrapper} onMouseOver={() => setIsQrHovered(true)} onMouseLeave={() => setIsQrHovered(false)}>
                  <div className={styles.iconView}>
                    <div className={styles.outlineIcon}>
                      <IconOutline />
                    </div>
                    <div className={styles.hoverOutlineIcon}>
                      <IconHoverOutline />
                    </div>
                  </div>
                  <QRCode
                    value={url}
                    size={width > 800 ? 250 : width < 620 ? 140 : 180}
                    imageSettings={{src: iconSrc, width: 24, height: 24, excavate: true}}
                    level={'M'}
                    renderAs={'svg'}
                  />
                </div>
              <div className={styles.orView} >Or</div>
                {<div className={styles.hoverTipView} style={{display: isLinkHovered ? "block" : "none"}}>
                  <div className={styles.hoverTipTitle}>Instructions</div>
                  <div className={styles.hoverTipDetail}>{ (exitTicket && hasNextContent) ? "Students visit op.school in their browser and enter the code below." : "Send the link to your students. They can then paste the link in a web browser to answer the questions"}</div>
                </div>}
                <div className={styles.linkWrapper} onMouseOver={() => setIsLinkHovered(true)} onMouseLeave={() => setIsLinkHovered(false)}>
                  <div className={styles.iconView}>
                    <div className={styles.outlineIcon}>
                      <IconOutline />
                    </div>
                    <div className={styles.hoverOutlineIcon}>
                      <IconHoverOutline />
                    </div>
                  </div>
                  <CopyToClipboard text={shortLink} onCopy={handleCopyToClipboard(shortLink)}>
                    <div className={styles.linkView}>
                      <div className={styles.visitText}>VISIT:</div>
                      <a className={styles.linkText} href='https://op.school' target="_blank" rel="noreferrer">https://op.school</a>
                      <div className={styles.codeTitle}>ENTER CODE:</div>
                      <div className={styles.codeView}>
                        {codeList.map((chr, index) => {
                          if (isNumber(chr)) {
                            return (
                              <span key={index} className={styles.numberCodeText}>{chr}</span>
                            )
                          } else {
                            return (
                              <span key={index} className={styles.codeText}>{chr}</span>
                            )
                          }
                          })
                        }
                      </div>
                    </div>
                  </CopyToClipboard>
                </div>
            </div>
            <CopyToClipboard text={longLink} onCopy={handleCopyToClipboard(longLink)}>
              <div className={styles.copyLinkTitle} onMouseOver={() => setCopyLinkHovered(true)} onMouseLeave={() => setCopyLinkHovered(false)}>
              {'Share Link'}
              </div>
            </CopyToClipboard>
            <div className={styles.emailCopyTipView} style={{display: copyLinkHovered ? "block" : "none"}}>
              <div className={styles.copyLinkMenuItem}>
                <strong>Click to copy</strong>&nbsp;{longLink}
              </div>
            </div>
          </div>
          <div className={styles.exitTicketBottomView}>
            <div className={styles.expiryInfoView}>
              <span>
                <strong>{Math.round((exitTicketActive?.expiryMinutes ?? 0)/60)}</strong> Minutes Left
              </span>
              <span>
                <strong>{exitTicketActive?.exitTicketCount}</strong> Responses Max
              </span>
            </div>
            <div className={styles.activeShowView}>
              <Button disabled={canceling || feedbackLoading} size='small' className={styles.exitTicketActiveButton} onClick={canceling || feedbackLoading ? () => {} : showExitTicketActive}
                leftIcon = { canceling || feedbackLoading ? <Spinner width={20} height={20} /> : <TicketIcon />}
                  label={formTypePreProgram || isPreProgramQuiz ? 'Pre-Program Active' : formTypeExitTicket ? 'Exit Ticket Active': 'Research Survey Active'} rightIcon={<WarningIcon width={20} height={21} className={styles.warningIcon}/>}
              />
              <div className={styles.dropDownActiveMenu} style={{display: isActiveHovered ? "block" : "none", width: formTypeExitTicket ? '220px' : isPreProgramQuiz ? '242px' : '270px'}}>
                <div className={styles.activeInfoMenu} onClick={e => e.stopPropagation()}>
                  <OutlineIcon width={21} className={styles.outlineIcon} />
                  <div className={styles.activeInfo}>
                    <span>
                      <strong>{Math.round((exitTicketActive?.expiryMinutes ?? 0)/60)}</strong> Minutes Left
                    </span>
                    <span>
                      <strong>{exitTicketActive?.exitTicketCount}</strong> Responses Max
                    </span>
                  </div>
                </div>
                <div className={styles.dropDownMenuitem} onClick={cancelExitTicket}>
                  {'Cancel'}
                </div>
                <div className={styles.dropDownMenuitem} onClick={generateExitTicket}>
                  {'Regenerate'}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (!feedbackForm && !hasNextContent) {
      return (
        <div className={styles.generateContent} style={{ width: 'auto' }}>
          {
            <>
              <div className={exitTicket ? styles.exitTicketTitle : styles.qrLessonName}>{isPreProgramQuiz ? 'PRE-PROGRAM Quiz' : name}</div>
              {exitTicket ? <div className={styles.exitTicketDescription}>{'Click the button to generate a Link for your students'}</div> :
              !!jsonFormData.instructions && <div className={styles.description}>{jsonFormData.instructions}</div>}
              {exitTicket ? <Button disabled={canceling || feedbackLoading} className={styles.exitTicketGenerateButton}  onClick={handleGenerateForm}
                leftIcon={canceling || feedbackLoading ? <Spinner width={33} height={33} /> : <TicketIcon width={33} height={33}/>} label={formTypePreProgram || isPreProgramQuiz ? 'GENERATE PRE-PROGRAM' : formTypeExitTicket ? 'GENERATE EXIT TICKET' : 'GENERATE SURVEY'} /> :
                <Button className={styles.generateBtn} isLoading={false} disabled={false} label={'Continue'} onClick={handleGenerateForm}/>}
            </>
          }
        </div>
      );
    } else if (!feedbackForm && hasNextContent) {
      return (
        <div className={styles.generateContent} style={{ width: 'auto' }}>
          <div className={exitTicket ? styles.exitTicketTitle : styles.qrLessonName}>{isPreProgramQuiz ? 'PRE-PROGRAM Quiz' : name}</div>
          {exitTicket ? <div className={styles.exitTicketDescription}>{'Click the button to generate a Link for your students'}</div> :
          !!jsonFormData.instructions && <div className={styles.description}>{jsonFormData.instructions}</div>}
          {exitTicket ? <Button disabled={canceling || feedbackLoading} className={styles.exitTicketGenerateButton}  onClick={handleGenerateForm}
            leftIcon={canceling || feedbackLoading ? <Spinner width={33} height={33} /> : <TicketIcon width={33} height={33}/>} label={formTypePreProgram || isPreProgramQuiz ? 'GENERATE PRE-PROGRAM' : formTypeExitTicket ? 'GENERATE EXIT TICKET' : 'GENERATE SURVEY'} /> :
            <Button className={styles.generateBtn} isLoading={false} disabled={false} label={'Continue'} onClick={handleGenerateForm}/>}
        </div>
      );
    } else if (((exitTicket && exitTicketActive && exitTicketActive!.expiryMinutes > 0) || (!exitTicket && timeLeft > 0)) && feedbackForm) {
      const url = exitTicket ? exitTicketActive!.copyLink : createURL(feedbackForm.link ?? '');
      return (
        <div className={styles.wrapper} ref={containerRef}>
          <div className={styles.mainContent}>
            <div className={styles.mainTitle}>
              {name}
            </div>
            {/* {!!jsonFormData.instructions && <div className={styles.description}>{jsonFormData.instructions}</div>} */}
            <div className={styles.qrContent}>
                {<div className={styles.hoverQrTipView} style={{display: isQrHovered ? "block" : "none"}}>
                  <div className={styles.hoverTipTitle}>Scan the QR code</div>
                  <div className={styles.hoverTipDetail}>And answer the questions on your device</div>
                </div>}
                <div className={styles.qrCodeWrapper} onMouseOver={() => setIsQrHovered(true)} onMouseLeave={() => setIsQrHovered(false)}>
                  <div className={styles.iconView}>
                    <div className={styles.outlineIcon}>
                      <IconOutline />
                    </div>
                    <div className={styles.hoverOutlineIcon}>
                      <IconHoverOutline />
                    </div>
                  </div>
                  <QRCode
                    value={url}
                    size={width > 800 ? 250 : width < 620 ? 140 : 180}
                    imageSettings={{src: iconSrc, width: 24, height: 24, excavate: true}}
                    level={'M'}
                    renderAs={'svg'}
                  />
                </div>
              <div className={styles.orView} >Or</div>
                {<div className={styles.hoverTipView} style={{display: isLinkHovered ? "block" : "none"}}>
                  <div className={styles.hoverTipTitle}>Instructions</div>
                  <div className={styles.hoverTipDetail}>{ (exitTicket && hasNextContent) ? "Students visit op.school in their browser and enter the code below." : "Send the link to your students. They can then paste the link in a web browser to answer the questions"}</div>
                </div>}
                <div className={styles.linkWrapper} onMouseOver={() => setIsLinkHovered(true)} onMouseLeave={() => setIsLinkHovered(false)}>
                  <div className={styles.iconView}>
                    <div className={styles.outlineIcon}>
                      <IconOutline />
                    </div>
                    <div className={styles.hoverOutlineIcon}>
                      <IconHoverOutline />
                    </div>
                  </div>
                  <CopyToClipboard text={shortLink} onCopy={handleCopyToClipboard(shortLink)}>
                    <div className={styles.linkView}>
                      <div className={styles.visitText}>VISIT:</div>
                      <div className={styles.linkText}>https://op.school</div>
                      <div className={styles.codeTitle}>ENTER CODE:</div>
                      <div className={styles.codeView}>
                        {codeList.map((chr, index) => {
                          if (isNumber(chr)) {
                            return (
                              <span key={index} className={styles.numberCodeText}>{chr}</span>
                            )
                          } else {
                            return (
                              <span key={index} className={styles.codeText}>{chr}</span>
                            )
                          }
                          })
                        }
                      </div>
                    </div>
                  </CopyToClipboard>
                </div>

            </div>
            <CopyToClipboard text={longLink} onCopy={handleCopyToClipboard(longLink)}>
              <div className={styles.copyLinkTitle} onMouseOver={() => setCopyLinkHovered(true)} onMouseLeave={() => setCopyLinkHovered(false)}>
              {'Share Link'}
              </div>
            </CopyToClipboard>
            <div className={styles.emailCopyTipView} style={{display: copyLinkHovered ? "block" : "none"}}>
              <div className={styles.copyLinkMenuItem}>
                <strong>Click to copy</strong>&nbsp;{longLink}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.generateContent}>
          <div className={styles.qrLessonName}>{isPreProgramQuiz ? 'Quiz Link Expired' : 'Survey Link Expired'}</div>
          <div className={styles.description}>Click button below to regenerate the Survey QR Code.</div>
          <div className={styles.reGenerateBtn} onClick={generateLink}>{isPreProgramQuiz ? 'Regenerate Pre-Program Quiz' : `Regenerate Survey QR Code`}</div>
        </div>
      )
    }
  }, [width, isPreProgramQuiz, copyLinkHovered, shortLink, longLink, codeList, formTypePreProgram, formTypeExitTicket, exitTicketActive, feedbackForm, hasNextContent, exitTicket, timeLeft, name, isActiveHovered, canceling, feedbackLoading, cancelExitTicket, generateExitTicket, generateLink, isQrHovered, isLinkHovered, handleCopyToClipboard, jsonFormData.instructions, handleGenerateForm]);

  return (
    <>
    <div className={styles.backdrop} onClick={() => setIsActiveHovered(false)}/>
      {<div className={styles.confirmView} style={{display: showConfirm ? "block": "none"}}>
        <div className={styles.confirmDetail}>Link Copied Successfully! </div>
      </div>
      }
      {<div className={styles.notifySubView2} style={{display: showRememberNotify ? "grid" : "none"}}>
        <InfoCircleIcon className={styles.infoCircle} />
        <div className={styles.notifyDetail}>
          <p>Please distribute the Exit Ticket Link to students</p>
        </div>
      </div>}
      {content}
      {completeModal && <CompleteModal open={completeModal} loading={false} onClose={() => goBack && goBack()} onContinue={() => setCompleteModal(false)} onComplete={handleCompleteLesson} onJustView={handleNotStartedLesson} completed/>}
      {showExitModal && <GenerateExitTicketLinkModal sllLesson={lesson} sllCourse={course} open={showExitModal} formData={formData} onClose={() => setShowExitModal(false)} onActiveExitTicket={handleActiveFormPreview} isSll ausPreProgram={isPreProgramQuiz} gradeName={grade?.label}/>}
    </>
  );
}

export default memo(FormGenerateContent);
